import React, {useEffect, useRef, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';

import connect from "react-redux/es/connect/connect";
import Switch from '@material-ui/core/Switch';
import Typography from "@material-ui/core/Typography";
import {Redirect} from "react-router-dom";
import {VERSAO} from "../../config";
import {getUrlGet, postCorteRespostas} from "../../actions/orderActions";
import {useDispatch} from "react-redux";




const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  formControl: {
    marginRight: theme.spacing(1),
    minWidth: theme.spacing(1) * 10,
    width: '100%'
  },
  relative: {
    position: 'relative'
  },
  textControl : {
    paddingTop: 0,
    paddingBottom: 5,
  },
  switchControl : {
    width: 58,
    height: 38,
    display: 'inline-flex',
    padding: 12,
    zIndex: 0,
    overflow: 'hidden',
    position: 'relative',
    boxSizing: 'border-box',
    flexShrink: 0,
    verticalAlign: 'middle',
    paddingBottom: 5,
  },
  tableTextField: {
    width: '100%',
    '& fieldset': {
      borderRadius: '0'
    },
    '& input': {
      padding: '20px'
    }
  },
  row: {
    marginBottom: theme.spacing(1),
  }
}));




const AppStatus = ({
    isAuthenticated,
    auth

}) => {


  const classes = useStyles();
  const [isClosed, setClose] = React.useState(false);
  const [urlGet, setUrlGet] = useState('http://127.0.0.1:5010/zebra/corte?os=172453&&banda=AL5&&largura=240&&comprimento=3205&&validacao=829&&fabricante=FIRESTONE&&modelo=FS440&&fogo=48157&&dot=3019&&modeloEtiqueta=2');
  const inputRef = useRef();
  const dispatch = useDispatch();


  let timeout = null;

  const handleClose = () => {
     setClose(true)
  };

    const apagaChave = () => {
        localStorage.clear();
    };

    if (isClosed) {
      return(<Redirect path="/"/> )
    }

  const handleGet = async () => {
    const x = await dispatch(getUrlGet(urlGet) );

  }
  return (
    <div>
      <Dialog fullWidth maxWidth={'md'} open={true} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Situação do sistema</DialogTitle>
        <DialogContent>
          <Grid item xs={12} container spacing={3}>

            <Grid item xs={12} md={12}  lg={12} container>
              <Grid item xs={12} md={12} lg={12} className={classes.row} container>

                  <Grid item xs={12} md={12}  lg={12} container>
                     <Typography>{isAuthenticated?  'Usuário autenticado.' : 'Não autenticado.' }</Typography>
                  </Grid>
                  <Grid item xs={12} md={12}  lg={12} container>
                      <Typography variant="body2">{isAuthenticated?  `Chave de acesso: ${auth.id}` : 'Não autenticado.' }</Typography>
                      <Button onClick={apagaChave} >Apagar chave</Button>
                  </Grid>


              </Grid>
              <Grid item xs={12} md={12} lg={12} className={classes.row} container>

                <Grid item xs={12} md={3}  lg={12} container>
                  <Typography>Versao: {VERSAO}</Typography>
                </Grid>

                <Grid item xs={12} md={3}  lg={12} container>
                  <Typography>GET</Typography>
                  <TextField  InputProps={{
                    classes: {

                    },

                  }} required fullWidth  inputRef={inputRef} id="idurlGet" onChange={(event) => setUrlGet(event.target.value)} label=""  id="tburlGet" label="" value={urlGet} />

                </Grid>

                <Grid item xs={12} md={3}  lg={3} container>
                  <Button onClick={handleGet}>GET</Button>
                </Grid>

                <Grid item xs={12} md={12}  lg={3} container>

                </Grid>




              </Grid>

              <Grid item xs={12} md={12} lg={12} className={classes.row} container>

                  <Grid item xs={12} md={3}  lg={3} container>

                  </Grid>

                     <Grid item xs={12} md={3}  lg={3} container>

                    </Grid>

                    <Grid item xs={12} md={3}  lg={3} container>

                    </Grid>

                    <Grid item xs={12} md={3}  lg={3} container>

                    </Grid>
              </Grid>

              <Grid item xs={12} md={12} lg={12} className={classes.row} container>

                <Grid item xs={12} md={3}  lg={2} container>

                </Grid>

              </Grid>

            </Grid>
          </Grid>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="default">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.id !== null,
    auth : state.auth,
  }
}

export default connect(mapStateToProps, {

})(AppStatus)
